/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Folder } from '../models/Folder';
import type { FolderDetail } from '../models/FolderDetail';
import type { GetUploadUrl } from '../models/GetUploadUrl';
import type { Media } from '../models/Media';
import type { MediaGet } from '../models/MediaGet';
import type { PaginatedFolderList } from '../models/PaginatedFolderList';
import type { PaginatedMediaGetList } from '../models/PaginatedMediaGetList';
import type { PatchedFolder } from '../models/PatchedFolder';
import type { UploadUrl } from '../models/UploadUrl';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class FilesService {

  /**
   * @param ordering Ordering fields: created, modified, name
   * @param page A page number within the paginated result set.
   * @param pageSize Number of results to return per page.
   * @param search Search fields: name
   * @returns PaginatedFolderList 
   * @throws ApiError
   */
  public static filesFoldersList(
ordering?: string,
page?: number,
pageSize?: number,
search?: string,
): CancelablePromise<PaginatedFolderList> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/files/folders/',
      query: {
        'ordering': ordering,
        'page': page,
        'page_size': pageSize,
        'search': search,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns Folder 
   * @throws ApiError
   */
  public static filesFoldersCreate(
requestBody: Folder,
): CancelablePromise<Folder> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/files/folders/',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @param id A unique integer value identifying this folder.
   * @returns FolderDetail 
   * @throws ApiError
   */
  public static filesFoldersRetrieve(
id: number,
): CancelablePromise<FolderDetail> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/files/folders/{id}/',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @param id A unique integer value identifying this folder.
   * @param requestBody 
   * @returns Folder 
   * @throws ApiError
   */
  public static filesFoldersPartialUpdate(
id: number,
requestBody?: PatchedFolder,
): CancelablePromise<Folder> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/files/folders/{id}/',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @param id A unique integer value identifying this folder.
   * @returns void 
   * @throws ApiError
   */
  public static filesFoldersDestroy(
id: number,
): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/files/folders/{id}/',
      path: {
        'id': id,
      },
    });
  }

  /**
   * For admins only
   * @param author 
   * @param category * `contract` - Contract
 * * `policy` - Policy
 * * `order` - Order
 * * `common` - Common
 * * `user` - User
 * * `receipt` - Receipt
 * * `invoice` - Invoice
 * * `claim` - Claim
   * @param excludeIds comma separated list
   * @param folder 
   * @param ids comma separated list
   * @param ordering Ordering fields: created, modified, name
   * @param page A page number within the paginated result set.
   * @param pageSize Number of results to return per page.
   * @param search Search fields: name
   * @returns PaginatedMediaGetList 
   * @throws ApiError
   */
  public static filesMediaList(
author?: number,
category?: 'claim' | 'common' | 'contract' | 'invoice' | 'order' | 'policy' | 'receipt' | 'user',
excludeIds?: string,
folder?: number,
ids?: string,
ordering?: string,
page?: number,
pageSize?: number,
search?: string,
): CancelablePromise<PaginatedMediaGetList> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/files/media/',
      query: {
        'author': author,
        'category': category,
        'exclude_ids': excludeIds,
        'folder': folder,
        'ids': ids,
        'ordering': ordering,
        'page': page,
        'page_size': pageSize,
        'search': search,
      },
    });
  }

  /**
   * For admins only
   * @param id A unique integer value identifying this media.
   * @returns MediaGet 
   * @throws ApiError
   */
  public static filesMediaRetrieve(
id: number,
): CancelablePromise<MediaGet> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/files/media/{id}/',
      path: {
        'id': id,
      },
    });
  }

  /**
   * For admins only
   * @param requestBody 
   * @returns UploadUrl 
   * @throws ApiError
   */
  public static filesMediaUploadUrlCreate(
requestBody: GetUploadUrl,
): CancelablePromise<UploadUrl> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/files/media/upload-url/',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Internal MinIO webhook
   * @param requestBody 
   * @returns Media 
   * @throws ApiError
   */
  public static filesMediaWebhookCreate(
requestBody: Media,
): CancelablePromise<Media> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/files/media/webhook/',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

}
